import { createStyles } from 'antd-style';

export const useVersionIncompatibilityDialogStyles = createStyles(() => ({
  dialog: {
    '.ant-modal-body': {
      '> .ant-row:last-child': {
        '> .ant-col': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',

          '> .ant-btn': {
            width: 190,
          },
        },
      },
    },
  },
}));
